"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewClient = useViewClient;
const ViewClient_1 = require("@juvare/platform-sdk-js/ViewClient");
const react_1 = __importDefault(require("react"));
function useViewClient(view, baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new ViewClient_1.ViewClient(view, baseUrl, tokenProvider), [view, baseUrl, tokenProvider]);
}
